import { haptics } from '../platform';

const MIN_HAPTIC_INTERVAL_MS = 90;
const HAPTIC_SUPPRESSION_KEY = '__nanoBananaSuppressHapticsUntil';

let lastHapticAt = 0;

export function suppressHaptics(durationMs = 1200) {
  if (typeof window === 'undefined') return;
  window[HAPTIC_SUPPRESSION_KEY] = Date.now() + durationMs;
}

export function isHapticSuppressed() {
  if (typeof window === 'undefined') return false;
  return Date.now() < (window[HAPTIC_SUPPRESSION_KEY] || 0);
}

function triggerHaptic(method, arg) {
  if (isHapticSuppressed()) return;

  const now = Date.now();
  if (now - lastHapticAt < MIN_HAPTIC_INTERVAL_MS) return;
  lastHapticAt = now;

  try {
    if (method === 'selectionChanged') haptics.selection?.();
    else if (method === 'impactOccurred') haptics.impact(arg);
    else if (method === 'notificationOccurred') haptics.notification(arg);
  } catch (error) {
    if (import.meta.env.DEV) {
      console.warn('Telegram haptic feedback failed:', error);
    }
  }
}

export function hapticSelection() {
  triggerHaptic('selectionChanged');
}

export function hapticImpact(style = 'light') {
  triggerHaptic('impactOccurred', style);
}
